import * as i0 from "@angular/core";
var GoogleMapsService = /** @class */ (function () {
    function GoogleMapsService() {
        this.URL = "https://www.google.com/maps/dir/?api=1";
    }
    GoogleMapsService.prototype.navigateTo = function (location) {
        var url = this.URL;
        if (location.startPoint) {
            url += "&travelmode=driving&destination=" + location.startPoint.lat + "," + location.startPoint.long;
        }
        else {
            url += "&travelmode=driving&destination=" + encodeURI(location.name.replace(/ /g, ''));
        }
        window.open(url, '_blank');
    };
    GoogleMapsService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function GoogleMapsService_Factory() { return new GoogleMapsService(); }, token: GoogleMapsService, providedIn: "root" });
    return GoogleMapsService;
}());
export { GoogleMapsService };
